import React from 'react';
import ReactDOM from 'react-dom/client';
import { ClerkProvider } from '@clerk/clerk-react';
import '@fontsource-variable/inter';
import '@radix-ui/themes/styles.css';
import App from './App';
import './index.css';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
const clerkPublishableKey = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;
const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

root.render(
  clerkPublishableKey ? (
    <ClerkProvider publishableKey={clerkPublishableKey}>{app}</ClerkProvider>
  ) : (
    app
  )
);
